import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IState } from 'app/shared/models/state';
import { BootstrapCompleteAction } from 'app/bootstrap/bootstrap.actions';

@Injectable({
  providedIn: 'root'
})
export class BootstrapService {
  constructor(private store: Store<IState>) {}

  public boostrapComplete() {
    this.store.dispatch(new BootstrapCompleteAction());
  }
}
